export const generateTestId = (dataTestId: string) => ({
  component: dataTestId,
  input: `${dataTestId}-input`,
});

export const data = {
  title: 'My shiny component Input ',
};
